import React from 'react';
import Notifications, { NotificationQueueItem } from '../../../Notifications';
import { NotificationType } from '../../types';
import LabelAsNotification from './LabelAsNotification';

interface Props {}

const NotificationsForMM: React.FC<Props> = () => {
  return (
    <Notifications onlyUseRenderFunction>
      {(notification: NotificationQueueItem) => {
        switch (notification.type) {
          case NotificationType.LABEL_AS:
            return (
              <LabelAsNotification
                id={notification.id}
                queueName={notification.queueName}
                {...notification.params}
              />
            );
          default:
            return null;
        }
      }}
    </Notifications>
  );
};
NotificationsForMM.displayName = 'NotificationsForMM';

export default NotificationsForMM;
